import React, { useEffect, useState } from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import Topbar from "../../Layouts/Topbar";
import Header from "../../Layouts/Header";
import InnerBanner from "../../Layouts/InnerBanner";
import Footer from "../../Layouts/Footer";
import { API } from "../../constants";
import useCompanyStore from "../../hooks/useCompanyStore";

const Faq = () => {
  const { companyId } = useCompanyStore();
  const [faqs, setFaqs] = useState([]);
  const fetchFaq = async () => {
    try {
      const response = await fetch(API.LIST_FAQ + "/" + companyId, {
        method: "GET",
      });

      const result = await response.json();

      if (!response.ok || result.status === false) {
        setFaqs([]);
        return;
      }
      setFaqs(result.data);
    } catch (error) {
      setFaqs([]);
    }
  };

  useEffect(() => {
    if (!companyId) return;
    fetchFaq();
  }, [companyId]);

  return (
    <>
      <Topbar />
      <Header />
      <InnerBanner />

      <section className="faq-area py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="section-title text-center mb-4">
                <h2>Frequently Asked Questions</h2>
                <p>
                  Find answers to common questions about our services and
                  booking process.
                </p>
              </div>

              <Accordion defaultActiveKey="0" className="faq-accordion">
                {faqs.map((faq, index) => (
                  <Accordion.Item eventKey={index.toString()} key={index}>
                    <Accordion.Header>{faq.question}</Accordion.Header>
                    <Accordion.Body>{faq.answer}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};

export default Faq;
